module.exports = __webpack_public_path__ + "static/media/background-merge.a9469bd4.png";